import React from 'react';
import { siteConfig } from '../config/siteConfig';
import ScrollingTitle from '../components/ScrollingTitle/ScrollingTitle';
import NominateJuryForm from '../components/NominateJuryForm/NominateJuryForm';
import './Page.css';

const NominateJury = () => {
  const { nominateJury } = siteConfig;

  return (
    <div className="nominate-jury-page">
      <ScrollingTitle lines={nominateJury.title.lines} />

      <div className="page-container nominate-jury-content">
        <div className="page-content">
          <div className="content-section nominate-jury-main">
            <div className="nominate-jury-text">
              {nominateJury.content.description.split('\n\n').map((paragraph, index) => (
                <p key={index} className="nominate-jury-paragraph">{paragraph}</p>
              ))}
            </div>
          </div>
        </div>
      </div>

      <NominateJuryForm />
    </div>
  );
};

export default NominateJury;